exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.dialogimage .content{\n  position: relative;\n  display: flex;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n}\n\n.dialogimage .content img{\n  max-width: 80%;\n  margin: 10px;\n}\n\n.dialogimage .fab{\n  position: fixed;\n  z-index: 10;\n  bottom: 1%;\n  right: 3%;\n  color: white;\n}\n", ""]);

